import React from "react";
import ReactDOM from "react-dom";
import AdvanceNurseryModal from "./index";

export default async function renderAdvanceNurseryConfigurationModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<AdvanceNurseryModal {...rest} />, domTarget);
  }
}
